/**
 * Currency utilities — UAE-first with full multi-currency support
 */

export const CURRENCY_SYMBOLS = {
  AED: 'د.إ',
  SAR: 'ر.س',
  USD: '$',
  EUR: '€',
  GBP: '£',
  KWD: 'د.ك',
  QAR: 'ر.ق',
  BHD: 'د.ب',
  OMR: 'ر.ع',
  EGP: 'ج.م',
  JOD: 'د.ا',
  MAD: 'د.م',
  TND: 'د.ت',
  DZD: 'دج',
  IQD: 'ع.د',
  LYD: 'د.ل',
  LBP: 'ل.ل',
  SDG: 'ج.س',
  YER: 'ر.ي',
  INR: '₹',
  PKR: '₨',
  NGN: '₦',
  ZAR: 'R',
};

/** Return the symbol for a currency code; falls back to 'د.إ' */
export const getCurrencySymbol = (code) => {
  return CURRENCY_SYMBOLS[code] || code || 'د.إ';
};

/** Format a number with the currency symbol (Arabic locale) */
export const formatAmount = (amount, currencyCode = 'AED') => {
  const symbol = getCurrencySymbol(currencyCode);
  const formatted = Number(amount || 0).toLocaleString('ar-AE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formatted} ${symbol}`;
};
